import React, { useState } from 'react';
import { industryCategories } from '../data/images';

const ProvenIndustries = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="proven-industries" className="py-16 sm:py-24 bg-slate-950" data-testid="proven-industries-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <span className="text-violet-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Versatile & Scalable
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
            Proven Across
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-cyan-400">
              Industries
            </span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-2xl mx-auto">
            Our approach adapts to any organization. The principles of leadership, alignment, and communication are universal.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-8 sm:mb-10">
          {industryCategories.map((cat, i) => (
            <button
              key={cat.name}
              onClick={() => setActive(i)}
              data-testid={`industry-tab-${i}`}
              className={`px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 ${
                active === i
                  ? 'bg-white text-slate-950'
                  : 'bg-white/5 text-slate-400 border border-white/10 hover:border-white/20 hover:text-white'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Active Category Content */}
        <div className="text-center mb-6">
          <p className="text-slate-400 text-sm">{industryCategories[active].description}</p>
        </div>

        {/* Category Images */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4" data-testid="industry-images">
          {industryCategories[active].images.map((img, i) => (
            <div
              key={`${active}-${i}`}
              className="relative overflow-hidden rounded-xl group"
              data-testid={`industry-image-${i}`}
            >
              <div className="aspect-[4/3]">
                <img
                  src={img.src}
                  alt={img.label}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
                <span className="px-2.5 py-1 rounded-md bg-white/10 backdrop-blur-sm text-white text-xs font-semibold border border-white/20">
                  {img.label}
                </span>
                {img.metric && (
                  <p className="text-emerald-400/80 text-[10px] sm:text-xs mt-2 font-medium">{img.metric}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProvenIndustries;
